import type { Module } from "vuex";
import { z } from "zod";
import { apiPaths } from "@/dictionaries/api/paths";
import http from "@/utils/axios";

const accountCompletionResponse = z.object({
  complete_clinic_name: z.boolean(),
  complete_choose_user_services: z.boolean(),
  complete_set_calendar_schedule: z.boolean(),
  complete_choose_facility: z.boolean(),
  sms_verified: z.boolean(),
  complete_clinic_services: z.boolean(),
});

export interface AccountCompletion {
  completion: z.infer<typeof accountCompletionResponse> | null;
}

const module: Module<AccountCompletion, unknown> = {
  namespaced: true,
  state: {
    completion: null,
  },
  getters: {
    completion(state) {
      return state.completion;
    },
  },
  mutations: {
    setUser(state, newState: NonNullable<AccountCompletion["completion"]>) {
      state.completion = { ...newState };
      return state;
    },
  },
  actions: {
    async fetchAccountCompletion(ctx) {
      try {
        const { data: response } = await http.get<unknown>(
          apiPaths.accountCompletion.exact,
        );
        const data = accountCompletionResponse.parse(response);
        ctx.commit("setUser", data);
        return;
      } catch {}
    },
  },
};

export default module;
